<template>
	<div class="flex bg-white list-item margin-bottom-sm" @click="godetail(data)">
		<img class="cover margin-right-sm"  :src="data.logo" >
		<div class="text-left flex-sub flex flex-direction justify-between">
			<p class="titlw" :style="[{ fontSize:size+'px'}]">{{data.title}}</p>
			<p class="text-sm text-666">课程章节：共{{data.chapterCount}}节</p>
			<p class="text-bf text-bold text-prices" v-if="data.price == 0">免费</p>
			<p class="text-price text-bf text-bold text-prices" v-if="data.price != 0">{{data.price}}</p>
			<p class="buynum  text-sm text-ccc">{{data.pay_num}}人已购买下载</p>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
	  props: {
		size:{
			type: [String,Number],
			default:18
		},//标题大小
		type:{//1  免费    2   精品
			type: [String,Number],
			default:1
		},
		data:{
			type: Object,
			default:{}
		}
	  },
	  mounted(){
	    
	  },
	  methods: {
	    godetail(data){
			if(localStorage.getItem('user_token')){
				this.$router.push({
					name:'skillDetail',
					query: {
						id:data.id
					}
				})
			}else{
				Bus.$emit("showlogon")
			}
	    	
	    }
	  }
	};
</script>

<style scoped lang="less">
	.list-item{
		padding: 24px;
		border-radius: 20px;
		position: relative;
		.buynum{
			position: absolute;
			bottom: 24px;
			right: 24px;
		}
	}
	.cover{
		width: 90px;
		height: 115px;
	}
	.titlw{
		
	}
</style>



// WEBPACK FOOTER //
// src/components/list/skill-list.vue